export default __webpack_public_path__ + "static/media/build button.83444465.png";